import toIterable from './toIterable'

export default function iterable(data) {
  return toIterable(data)
}
